import { motion } from "framer-motion"
import { Lock, ShieldAlert } from "lucide-react"

export default function CartBlocker() {
  return (
    <div className="w-full h-screen overflow-hidden">
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white p-6 mmb:mb-20 smb:mb-0">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold">Acesso Restrito</h2>
          <motion.div
            initial={{ rotate: 0 }}
            animate={{ rotate: [0, -10, 10, -10, 10, 0] }}
            transition={{ duration: 1, delay: 0.5, repeat: Number.POSITIVE_INFINITY, repeatDelay: 2 }}
          >
            <Lock className="h-8 w-8 text-yellow-400" />
          </motion.div>
        </div>
        <p className="text-gray-300 mt-2">
          Você precisa estar logado para acessar seu carrinho de compras
        </p>
      </div>
      <div className="mmb:p-0 smb:p-6 smb:h-screen flex items-center flex-col justify-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mb-6 flex flex-col items-center text-center"
        >
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: [0.8, 1.1, 1] }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="mb-4 rounded-full bg-red-100 p-4"
          >
            <ShieldAlert className="h-12 w-12 text-red-500" />
          </motion.div>
          <h3 className="mmb:mb-0 smb:mb-2 text-xl font-semibold">Seu carrinho está bloqueado</h3>
          <p className="text-gray-500">
            Para garantir a segurança das suas compras, é necessário fazer login antes de acessar o carrinho.
          </p>
        </motion.div>

        <div className="flex justify-center">
          <a
            href="/login"
            className="gap-2 bg-gradient-to-r from-green-600 to-green-500 text-white hover:from-green-700 hover:to-green-600 px-6 py-3 rounded-md font-medium flex items-center"
          >
            Ir para página de login
          </a>
        </div>
      </div>
    </div>
  )
}